import { UIText2 } from '@cian/ui-kit';

import { type FC, type JSX, type MouseEvent as ReactMouseEvent } from 'react';

import styles from './CardNarrowMenuItem.css';

type TCardNarrowMenuItemProps = {
  title: string;
  icon: JSX.Element;
  onClick(event: ReactMouseEvent<HTMLElement>): void;
};

export const CardNarrowMenuItem: FC<TCardNarrowMenuItemProps> = ({ icon, onClick, title }) => {
  return (
    <button className={styles['container']} onClick={onClick}>
      {icon}
      <UIText2>{title}</UIText2>
    </button>
  );
};
